(ns frontend.view.settings2.security.ai-admin.model
  "State paths for the AI services admin panel (tenant-admin configuration of
   per-tenant AI providers and per-task-type routing).")

(def root-path [::state])

(def blank-service
  {:label    ""
   :provider nil
   :base-url ""
   :model    ""
   :api-key  ""
   :enabled? true})
